enum FieldType {
    Textbox = 1,
    Textarea = 2,
    Dropdown = 3,
    Checkbox = 4,
    CheckboxList = 5,
    CheckboxDropdown = 6,
    Radiobutton = 7,
    FileUpload = 8,
    DatePicker = 9,
    Hidden = 10,
    Rows = 11,
    Address = 12,
    SortCode = 13,
    Calculated = 14
}

export { FieldType };